import { render, staticRenderFns } from "./PostEventModal.vue?vue&type=template&id=627f3718&scoped=true"
import script from "./PostEventModal.vue?vue&type=script&lang=js"
export * from "./PostEventModal.vue?vue&type=script&lang=js"
import style0 from "./PostEventModal.vue?vue&type=style&index=0&id=627f3718&prod&lang=scss"
import style1 from "./PostEventModal.vue?vue&type=style&index=1&id=627f3718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627f3718",
  null
  
)

export default component.exports